import React, { useEffect, useState } from "react";
import api from "../../lib/api";

const Stat = ({ label, value, icon, color }) => (
  <div className="bg-zbeach-surface border border-zbeach-gold/15 rounded-2xl p-5" data-testid={`stat-${label}`}>
    <div className="flex items-start justify-between">
      <div>
        <div className="text-xs uppercase tracking-wider text-zbeach-muted">{label}</div>
        <div className="font-serif text-3xl text-zbeach-dark mt-1.5 font-semibold">{value}</div>
      </div>
      <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${color}`}>
        <i className={`fa-solid ${icon}`} />
      </div>
    </div>
  </div>
);

const Dashboard = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/dashboard/stats").then((r) => setStats(r.data));
  }, []);

  if (!stats) return <div className="text-zbeach-muted">Yükleniyor...</div>;

  return (
    <div className="space-y-8" data-testid="dashboard-page">
      <header>
        <h1 className="font-serif text-3xl text-zbeach-dark">Hoş Geldin</h1>
        <p className="text-zbeach-muted text-sm mt-1">Z Beach yönetim paneline genel bakış.</p>
      </header>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat label="Kategoriler" value={stats.totalCategories} icon="fa-layer-group" color="bg-zbeach-turquoise/15 text-zbeach-turquoise" />
        <Stat label="Toplam Ürün" value={stats.totalProducts} icon="fa-mug-saucer" color="bg-zbeach-gold/15 text-zbeach-gold" />
        <Stat label="Aktif Ürün" value={stats.activeProducts} icon="fa-check-circle" color="bg-green-100 text-green-700" />
        <Stat label="Pasif Ürün" value={stats.inactiveProducts} icon="fa-circle-pause" color="bg-zbeach-muted/15 text-zbeach-muted" />
        <Stat label="Bugün Görüntülenme" value={stats.todayViews} icon="fa-eye" color="bg-zbeach-sea/30 text-zbeach-turquoise" />
        <Stat label="Bugün Çağrılar" value={stats.todayCalls} icon="fa-bell-concierge" color="bg-amber-100 text-amber-700" />
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-zbeach-surface border border-zbeach-gold/15 rounded-2xl p-5">
          <h3 className="font-serif text-xl text-zbeach-dark mb-4">En Çok Görüntülenenler</h3>
          <div className="space-y-2.5">
            {stats.topProducts.length === 0 && <div className="text-sm text-zbeach-muted">Henüz veri yok.</div>}
            {stats.topProducts.map((p) => (
              <div key={p.id} className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-zbeach-sand overflow-hidden flex-shrink-0">
                  {p.image && <img src={p.image} alt="" className="w-full h-full object-cover" />}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-zbeach-dark truncate">{p.nameTR}</div>
                  <div className="text-xs text-zbeach-muted">{p.viewCount || 0} görüntülenme</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-zbeach-surface border border-zbeach-gold/15 rounded-2xl p-5">
          <h3 className="font-serif text-xl text-zbeach-dark mb-4">Son Garson Çağrıları</h3>
          <div className="space-y-2.5">
            {stats.recentCalls.length === 0 && <div className="text-sm text-zbeach-muted">Henüz çağrı yok.</div>}
            {stats.recentCalls.map((c) => (
              <div key={c.id} className="flex items-center justify-between text-sm">
                <div>
                  <div className="font-medium text-zbeach-dark">{c.areaName}</div>
                  <div className="text-xs text-zbeach-muted">{new Date(c.createdAt).toLocaleString("tr-TR")}</div>
                </div>
                <StatusBadge status={c.status} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const StatusBadge = ({ status }) => {
  const map = {
    pending: { c: "bg-amber-100 text-amber-700", t: "Bekliyor" },
    in_progress: { c: "bg-blue-100 text-blue-700", t: "İlgileniliyor" },
    completed: { c: "bg-green-100 text-green-700", t: "Tamamlandı" },
  };
  const s = map[status] || map.pending;
  return <span className={`text-xs px-2.5 py-0.5 rounded-full font-medium ${s.c}`}>{s.t}</span>;
};

export default Dashboard;
